import React, { Component } from 'react';

class AddRubroOnly extends Component {
    constructor(props) {
        super(props);
        this.removeRubro = this.removeRubro.bind(this);
    }

    removeRubro(id, typeInput) {
        this.props.removeRubro(id, typeInput);
    }

    render() {
        return (
            <li className="inlineListItem right-separator-xxs">
                <div className="btn-group">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{this.props.Descripcion}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.removeRubro(this.props.Id, this.props.TypeInput)}>
                        <span className="ti-close span-closable color-white" title="Quitar este permiso." key={this.props.key}></span>
                    </button>
                </div>
            </li>
        );
    }
};

export default AddRubroOnly;